class scraperRegister {

    static data = null;
    static images_available = null;

    static setScraperData(data){
        scraperRegister.data = JSON.stringify(data);
        try{
            sessionStorage.setItem('scraper', JSON.stringify(data));
        }catch (e) {}
    }

    static setImagesAvailableBoolean(data){
        scraperRegister.images_available = data;
        try{
            sessionStorage.setItem('scraper_images_available', data);
        }catch (e) {}
    }

    static getImagesAvailableBoolean(){
        let data = null;
        try{
            data = sessionStorage.getItem("scraper_images_available");
        }catch (e) {}
        return data?data:scraperRegister.images_available;
    }

    static getScraperData(){
        let data = null;
        try{
            data = sessionStorage.getItem("scraper");
        }catch (e) {}
        return data?data:scraperRegister.data;
    }

    static removeScraperData(){
        scraperRegister.data = null;
        try{
            sessionStorage.removeItem('scraper');
        }catch (e) {}
    }

    //SHORTENER
    static set(data){
        scraperRegister.setScraperData(data);
    }

    static get(){
        return scraperRegister.getScraperData();
    }

    static remove(){
        scraperRegister.removeScraperData();
    }

}

export {scraperRegister}


// WEBPACK FOOTER //
// ./src/services/scraperRegister.js